import React from 'react'
import { Inventory } from '../../../../../assets/icons';
import TitleSVG from '../../../../../utils/components/TitleSVG/TitleSVG';
import style from './ProductConsolidation.module.css'
import ListItems from './ListItems';
import Item from './Item';




const ProductsConsolidation = (

    { consolidateProducts, setSkipConsolidateProducts, limitConsolidateProducts }) => {

    const scrollPagination = (e) => {
        if (
            e.target.scrollTop + 1 >= e.target.scrollHeight - e.target.clientHeight) {
            setSkipConsolidateProducts(skipConsolidateProducts=>{
                console.log()
                return skipConsolidateProducts + limitConsolidateProducts});
        }
    }

    return (
        <div className={`${style.container}`}>
            <TitleSVG Icon={Inventory}
                titleHighlight={'Inventario'}
                title={' consolidado'} />

            <div className={style.record_grid_container}>
                <div className={style.record_grid} onScroll={scrollPagination}>
                    <div className={style.record_grid_title}>código</div>
                    <div className={style.record_grid_title}>nombre</div>
                    <div className={style.record_grid_title}>stock</div>
                    <div className={style.record_grid_title}>categoría</div>
                    <div className={style.record_grid_title}>sub categoría</div>
                    <ListItems>
                        {consolidateProducts.map(record => (
                            <Item
                                key={record._id}
                                code={record.products[0].code}
                                name={record.products[0].name}
                                stocks={record.stocks}
                                category={record.products[0].category.name}
                                subCategory={record.products[0].subcategory.name}
                            />
                        ))

                        }
                    </ListItems>


                </div>
            </div>
        </div>
    )
}

export default ProductsConsolidation